import { combineReducers } from "@reduxjs/toolkit";
import analytics from "./analytics/reducer";
import config from "./config";
import search from "./search";
import error from "./error";
import layout from "./layout";
import page from "./page";
import brands from "./brands";
import category from "./category";

import { reducer as savedItems } from "./savedItems";
import { reducer as adverts } from "./adverts";
import { reducer as facet } from "./facet";
import commonConfig from "../../config/common";
import { connectRouter } from "./router/routerAdapter";

export default (history = {}) =>
  combineReducers({
    router: connectRouter(history),
    analytics,
    config,
    search,
    error,
    layout,
    page,
    brands,
    category,
    savedItems,
    facet,
    ...(commonConfig.adverts ? { adverts } : undefined)
  });
